import { clearLegacyDemoEntityStorage } from './utils/clearLegacyDemoEntityStorage';
import { isCloudDemoRuntime } from '../shared/utils/publicDemoRuntime';

if (isCloudDemoRuntime()) {
  clearLegacyDemoEntityStorage();
}
